// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmArchToolKitDetail {
constructor({
        id = null,
        emArchToolKitId = '',
        emArchCostStatisticTypeId = '',
        resourceCode = '',
        count = '',
        remark = ''}
= {}) {
    this.id = id;
    this.emArchToolKitId = emArchToolKitId;
    this.emArchCostStatisticTypeId = emArchCostStatisticTypeId;
    this.resourceCode = resourceCode;
    this.count = count;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchToolKitDetail();
}

function gridFields() {
return Object.freeze([
        {
        key: 'emArchToolKitId',
        label: 'label.em.archive.emArchToolKitDetail.grid.emArchToolKitId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchCostStatisticTypeId',
        label: 'label.em.archive.emArchToolKitDetail.grid.emArchCostStatisticTypeId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchCostStatisticTypeName',
        label: 'label.em.archive.emArchToolKitDetail.grid.emArchCostStatisticTypeName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'resourceCode',
        label: 'label.em.archive.emArchToolKitDetail.grid.resourceCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'count',
        label: 'label.em.archive.emArchToolKitDetail.grid.count',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolKitDetail.grid.remark',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    emArchToolKitIdFilter : "",
    emArchCostStatisticTypeIdFilter : "",
    resourceCodeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'emArchToolKitIdFilter',
        label: 'label.em.archive.emArchToolKitDetail.filter.emArchToolKitId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emArchCostStatisticTypeIdFilter',
        label: 'label.em.archive.emArchToolKitDetail.filter.emArchCostStatisticTypeId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchCostStatisticType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'resourceCodeFilter',
        label: 'label.em.archive.emArchToolKitDetail.filter.resourceCode',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'resourceCode',
        label: 'label.em.archive.emArchToolKitDetail.entity.resourceCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'count',
        label: 'label.em.archive.emArchToolKitDetail.entity.count',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolKitDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmArchToolKitDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
